type ComparisonAsset = { code: string; baseAvailable?: number };

export const exchangeAssetsComparator = (
  a: ComparisonAsset,
  b: ComparisonAsset
) => {
  const baseAvailableDiff = (b.baseAvailable ?? 0) - (a.baseAvailable ?? 0);
  if (baseAvailableDiff !== 0) return baseAvailableDiff;
  return a.code.localeCompare(b.code);
};
